<template>
	<span>{{ `${prefix}${formattedCurrency}` }}</span>
</template>

<script>
export default {
	name: 'Currency',
	props: {
		value: {
			type: Number,
			default: 0,
		},
		code: {
			type: String,
			default: null,
		},
		prefix: {
			type: String,
			default: '',
		},
	},
	data() {
		return {};
	},
	computed: {
		formattedCurrency() {
			if (this.code === 'TWD') {
				return `${this.$n(this.value)} ${this.$t('navigation.wallet.points')}`;
			} else if (this.$n(this.value, 'currency', this.code)) {
				return this.$n(this.value, 'currency', this.code);
			}
			return `${this.$n(this.value)} ${this.code}`; // NX case
		},
	},
};
</script>
